import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tache-by-workflow',
  templateUrl: './tache-by-workflow.component.html',
  styleUrls: ['./tache-by-workflow.component.css']
})
export class TacheByWorkflowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
